// Personalized, gently-rotating romantic microcopy. Pure functions of the
// wedding record — no images, no network. Used in headers and the greeting.

export function daysUntil(date) {
  if (!date) return null
  return Math.ceil((new Date(date) - new Date()) / 86400000)
}

function firstNames(wedding) {
  const p1 = wedding?.partner1_name?.split(' ')[0] || ''
  const p2 = wedding?.partner2_name?.split(' ')[0] || ''
  return { p1, p2, both: p1 && p2 ? `${p1} & ${p2}` : (p1 || p2 || '') }
}

// A soft line that changes day-to-day so it feels alive, but is stable within
// a session (no flicker on re-render).
export function loveNote(wedding) {
  const { p1, p2 } = firstNames(wedding)
  const days = daysUntil(wedding?.wedding_date)
  let notes
  if (days != null && days > 0) {
    notes = [
      `${days} day${days === 1 ? '' : 's'} until you say "I do".`,
      `${days} day${days === 1 ? '' : 's'} to forever.`,
      p2 ? `${p2} can't wait for your day.` : 'Your day is coming.',
      p1 ? `${p1}, your forever is almost here.` : 'Your forever is almost here.',
      'Every little plan brings you closer.',
    ]
  } else if (days === 0) {
    notes = ['Today is the day. 🎉', 'Forever starts today.']
  } else if (days != null && days < 0) {
    notes = ['Forever started. 💍', 'Here\'s to the rest of your lives.']
  } else {
    notes = ['Your love story, beautifully organised.', 'One calm place for every moment.']
  }
  const idx = Math.floor(Date.now() / 86400000) % notes.length
  return notes[idx]
}

// Compact header tag, e.g. "Adaeze & Emeka · 142 days to forever"
export function countdownTag(wedding) {
  const { both } = firstNames(wedding)
  const days = daysUntil(wedding?.wedding_date)
  const prefix = both ? `${both} · ` : ''
  if (days == null) return both || null
  if (days > 0) return `${prefix}${days} day${days === 1 ? '' : 's'} to forever`
  if (days === 0) return `${prefix}today's the day 🎉`
  return both || null
}
